import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

import ListingInfo from '@appComponents/ListingInfo';
import {buildSpiideoGameDetailsColumns} from '@modules/events/utils/spiideoGameDetailsHelper';
export const SpiideoSubpartsContent = ({data}) => {
    const columns = buildSpiideoGameDetailsColumns(data);

    return (
        <div className='eventPageDetails spiideo-game-details'>
            <Grid columns={3}>
                {columns.map(({key, fields}) => (
                    <Grid.Column key={key}>
                        <ListingInfo data={fields}/>
                    </Grid.Column>
                ))}
            </Grid>
        </div>
    );
};

SpiideoSubpartsContent.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        lifecycle_state: PropTypes.string,
        game_id: PropTypes.string,
        pending_operation: PropTypes.string,
        is_shared: PropTypes.bool,
        reconciliation_datetime: PropTypes.string,
        creation_datetime: PropTypes.string,
        update_datetime: PropTypes.string,
        live_production_id: PropTypes.string,
        live_output_id: PropTypes.string,
        low_latency_production_id: PropTypes.string,
        low_latency_output_id: PropTypes.string,
    }).isRequired,
};
